/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ResponseExpertsSessionTypeLanguagePairResponse,
  UpdateLanguageAvailabilityPayload,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Experts<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Experts
   * @name DeleteExpertSessionTranscriptions
   * @summary Delete all call transcriptions for sessions conducted by a specific expert/psychologist (Auth policies: HostOrSupportOrManagingPsychologistPolicy)
   * @request DELETE:/api/v1/experts/{expertId}/transcriptions
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  deleteExpertSessionTranscriptions = (
    expertId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/experts/${expertId}/transcriptions`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Experts
   * @name GetExpertIdsWithLanguageAvailabilityExclusions
   * @summary Get the list of expert IDs that have at least one excluded (sessionType, language) pair configured. (Auth policies: HostOrSupportOrManagingPsychologistPolicy)
   * @request GET:/api/v1/experts/language-availability/exclusions
   * @secure
   * @response `200` `(string)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getExpertIdsWithLanguageAvailabilityExclusions = (
    params: RequestParams = {},
  ) =>
    this.http.request<string[], void>({
      path: `/api/v1/experts/language-availability/exclusions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Experts
 * @name GetLanguageAvailability
 * @summary Get the list of (sessionType, language) pairs that are excluded for a specific expert.
Read access is open to booking-flow clients in addition to admin roles. (Auth policies: GuestOrClientOrExpertOrSupportOrHostOrManagerPolicy)
 * @request GET:/api/v1/experts/{expertId}/language-availability
 * @secure
 * @response `200` `(ResponseExpertsSessionTypeLanguagePairResponse)[]` OK
 * @response `401` `void` Unauthorized
 * @response `403` `void` Forbidden
 */
  getLanguageAvailability = (expertId: string, params: RequestParams = {}) =>
    this.http.request<ResponseExpertsSessionTypeLanguagePairResponse[], void>({
      path: `/api/v1/experts/${expertId}/language-availability`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Experts
   * @name UpdateLanguageAvailability
   * @summary Replace the list of excluded (sessionType, language) pairs for a specific expert. (Auth policies: HostOrSupportOrManagingPsychologistPolicy)
   * @request PUT:/api/v1/experts/{expertId}/language-availability
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateLanguageAvailability = (
    expertId: string,
    data: UpdateLanguageAvailabilityPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/experts/${expertId}/language-availability`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
